import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  TableSortLabel,
  TablePagination,
  Paper,
  Tooltip,
} from "@material-ui/core";
import { DashboardContext } from "../../context/DashboardContext";
import _ from "lodash";
import TableContextRenderer from "../dashboard/TableContentRenderer";
import CommonUtils from "../../utils/commonUtils";
import DashboardMode from "../../constants/DashboardMode";
import { ReactComponent as Info } from "../../assets/icons/information.svg";
import "./table.scss"

const RequestTable = (props) => {
  const { headers, dataChanged } = props;
  const history = useHistory();
  const location = useLocation();
  const pageNumber = new URLSearchParams(location.search).get("pageNum");
  const {
    loading,
    requests,
    totalPages,
    currentPage,
    rowsPerPage,
    _setSort,
    _getSort,
    _setCurrentPage,
    _setRowsPerPage,
    dashboardView,
    showLoading,
  } = useContext(DashboardContext);

  useEffect(() => {
    // Need to improve the below logic
    const lastViewedJobId = localStorage.getItem("lastViewedJobId");
    if (lastViewedJobId) {
      const element = document.getElementById(lastViewedJobId);
      if (element) {
        CommonUtils.scrollToTarget(element);
        element.classList.add('highlighted');
        setTimeout(() => {
          element.classList.remove('highlighted');
        }, 4000);
        localStorage.setItem("lastViewedJobId", null);
      }
    }
  }, [requests]);

  useEffect(() => {
    const pageNum = parseInt(pageNumber, 10) || 1;
    if (pageNum !== currentPage) {
      showLoading();
      _setCurrentPage(pageNum);
    }
    // eslint-disable-next-line
  }, [pageNumber]);

  const handleChangePage = (event, newPage) => {
    showLoading();
    const activePage = parseInt(newPage, 10) + 1;
    _setCurrentPage(activePage);
    history.push(`/?pageNum=${activePage}`);
  };

  const handleChangeRowsPerPage = (event) => {
    showLoading();
    _setRowsPerPage(parseInt(event.target.value, 10));
    _setCurrentPage(1);
  };

  const requestHeaders = (headersArray) => {
    const mapHeaders = _.map(headersArray, (column) => {
      if (column.label === "Job ID") {
        return null;
      }
      if (column.label === "Assigned to") {
        return null;
      }
      return column;
    });
    return _.filter(mapHeaders, (column) => {
      return !_.isEmpty(column);
    });
  };

  if (dashboardView === DashboardMode.JOBS) {
    return null;
  }
  return (
      <>
        <Grid
          item
          xs={12}
          className="dashboardGrid">
            {loading ? null
              : !_.isEmpty(requests) ? null
              : //Keeping this in case we need to show current sort text
                //   (          "The results are sorted by " +
                // _.startCase(_.keys(_getSort())[0]) +
                // " in " +
                // (_.get(_getSort(), _.keys(_getSort())[0]) === "desc" ? " descending" : " ascending") +
                // " order"
                // )
              <div className="tableInfoDiv">
                  <span className="tableInfoSpan">
                    No request found
                  </span>
              </div>
            }
          <TableContainer component={Paper} className="dashboardTableContainer">
            {_.isEmpty(requests) ? null : (
              <Table id="job_table" stickyHeader aria-label="sticky table">
                <TableHead
                  id={"job_head"}
                  className="tableHead">
                  <TableRow key={"job_header_row"}>
                    {/* Need to change below condition if no jobs found in request */}
                    {_.map(headers, (column, index) => (
                      <TableCell
                        key={"job_header_" + index}
                        className="dashboardTableHeader"
                        style={{
                          width: _.get(column, "width", "8%"),
                        }}
                      >
                        <TableSortLabel
                          className="tableSort"
                          hidden={_.isEmpty(column.label)}
                          active={_.isEqual(_.keys(_getSort())[0], _.get(column, "value"))}
                          direction={_.get(_getSort(), _.keys(_getSort())[0]) === "asc" ? "asc" : "desc"}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            let direction = "";
                            if (_.isEqual(_.keys(_getSort())[0], _.get(column, "value"))) {
                              direction = _.get(_getSort(), _.keys(_getSort())[0]) === "asc" ? "desc" : "asc";
                            } else {
                              direction = "asc";
                            }
                            let obj = {};
                            obj[_.get(column, "value")] = direction;
                            _setSort(obj);
                            showLoading();
                          }}>
                          {_.has(column, "title") ? (
                            <span>
                              <span>{column.label}</span>
                              <Tooltip
                                title={column.title}
                                interactive
                                placement="top"
                                arrow
                                classes={{ tooltip: "tableTooltip"}}>
                                <Info className="tableHeaderIcon"/>
                              </Tooltip>
                            </span>
                          ) : (
                            <span>{column.label}</span>
                          )}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody
                  className="tableBody"
                  id={"table_container"}>
                  <TableContextRenderer
                    dataChanged={dataChanged}
                    showJobs={dashboardView === DashboardMode.JOBS}
                    jobs={null}
                    requests={requests}
                    headers={dashboardView === DashboardMode.JOBS ? headers : requestHeaders(headers)}
                    order={_.get(_getSort(), _.keys(_getSort())[0])}
                    field={_.keys(_getSort())[0]}
                  />
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </Grid>
        <Grid
            item
            xs={12}>
          {_.isEmpty(requests) ? null : (
            <TablePagination
              component="div"
              className="tablePagination"
              count={totalPages}
              page={currentPage - 1}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              nextIconButtonText="Next Page"
              backIconButtonText="Previous Page"
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Grid>
      </>
  );
};

export default RequestTable;